export default __webpack_public_path__ + "static/media/249111.27a0f286.jpg";